import { Directive, Inject, ElementRef, Renderer2, Input, HostListener } from '@angular/core';

/**
 * Temporary directive to handle [ui-sref] in Angular 2+ templates in an hybrid project.
 *
 * Usage:
 *   <a ui-sref="document.list">Documents</a>
 *
 * OPTIONAL PARAMETERS (BINDINGS)
 *
 * @param {Object} ui-sref-params         ui-router state params
 * @param {Object} ui-sref-opts           ui-router routing options
 *
 * Usage:
 *   <a ui-sref="document.view" [ui-sref-params]="{ id: document.id }" [ui-sref-opts]="{ reload: true }">Document name</a>
 *
 * WARNING:
 * The legacy ui-sref syntax mixing a state name with params >> document.view({ id: document.id }) << is not supported anymore and will throw an error.
 * Params must be passed via the [ui-sref-params] attribute as explained above.
 */

@Directive({
  selector: '[ui-sref]',
})

export class UISrefDirective {

  @Input('ui-sref') state: string;
  @Input('ui-sref-params') params: any;
  @Input('ui-sref-opts') options: any;

  constructor(@Inject('$state') private $state, public _el: ElementRef, public _renderer: Renderer2) {}

  ngOnInit() {
    this._renderer.removeAttribute(this._el.nativeElement, 'href');

    if (!this.isValid(this.state)) {
      throw new Error(`Parse error: ${this.state} is not a valid ui-sref state name. Params must be passed via the [ui-sref-params] binding attribute in Angular 2+`);
    }
  }

  @HostListener('click') go() {
    this.$state.go(this.state, this.params, this.options);

    return false;
  }

  private isValid(state: string) {
    // Make sure the state name does not contains params (eg. document.group({ id: group.id }))
    const regex = /[A-z\.]+\((.+)\)/;
    return state && !state.match(regex);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/directives/ui-sref.directive.ts